<template>
  <v-app>
    <v-main>
      <!-- <Header v-if="$route.path == '/'" :title="$t('name')"></Header> -->
      <notifications
          width="400px"
          animation-name="v-fade-down"
          group="failmessages"
          position="top center"
          :duration="999999999"
      >
        <template slot="body" slot-scope="props">
          <v-alert
            class="notification-alert error-alert"
            border="left"
            colored-border
            elevation="4"
            type="error"
            dismissible
            @input="props.close"
          >
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <v-icon class="mr-3">mdi-alert-circle</v-icon>
              </v-col>
              <v-col>
                <div class="notification-title">Error</div>
                <div class="notification-message">{{ $t(props.item.text) }}</div>
              </v-col>
            </v-row>
          </v-alert>
        </template>
      </notifications>
      <notifications
          width="400px"
          animation-name="v-fade-down"
          group="successmesages"
          position="top center"
          :duration="999999999"
      >
        <template slot="body" slot-scope="props">
          <v-alert
            class="notification-alert success-alert"
            border="left"
            colored-border
            elevation="4"
            type="success"
            dismissible
            @input="props.close"
          >
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <v-icon class="mr-3">mdi-check-circle</v-icon>
              </v-col>
              <v-col>
                <div class="notification-title">Success</div>
                <div class="notification-message">{{ $t(props.item.text) }}</div>
              </v-col>
            </v-row>
          </v-alert>
        </template>
      </notifications>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
[dir="rtl"],
[dir="rtl"] .v-application,
[dir="rtl"] body,
.font-arabic,
.arabic-font {
  font-family: 'Almarai', -apple-system, BlinkMacSystemFont, sans-serif !important;
}

.v-application--wrap {
  min-height: calc(100vh - 70px);
}

header.px-5.py-5.v-sheet.theme--dark.elevation-0.v-toolbar.v-app-bar.v-app-bar--fixed {
  padding: 0 !important;
  display: flex;
}

.v-progress-circular.loading-indicator.v-progress-circular--visible.v-progress-circular--indeterminate {
    height: 110vh !important;
    width: 100% !important;
    -webkit-backdrop-filter: blur(2.5px);
    backdrop-filter: blur(2.5px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
}

.v-progress-circular > svg {
    width: 70px;
    height: 70px;
    color: #156967;
}

.txt-field .v-input__slot {
    background-color: white !important;
    /* border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important; */
}

.login-icon::before{
    border: 2px solid dimgray !important;
    border-radius: 100% !important;
    padding: 7px !important;
}

.input-field > .v-input__control > .v-input__slot:before,
.input-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
  display: none !important;
}

[dir="rtl"] .input-field label{
  right: 0 !important;
  left: auto !important;
  transform-origin: top right !important;
  text-align: right !important
}

[dir="rtl"] .input-field .v-input__prepend-inner{
  padding-left: 10px !important;
}

[dir="ltr"] .input-field .v-input__prepend-inner{
  padding-right: 10px !important;
}

/* Notification Styles */
.notification-alert {
  border-radius: 8px !important;
  margin-bottom: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.notification-alert .v-alert__content {
  padding: 16px !important;
}

.notification-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.notification-message {
  font-size: 14px;
  line-height: 1.4;
}

.error-alert {
  background-color: #ffebee !important;
  border-left-color: #f44336 !important;
}

.error-alert .notification-title {
  color: #c62828;
}

.success-alert {
  background-color: #e8f5e8 !important;
  border-left-color: #4caf50 !important;
}

.success-alert .notification-title {
  color: #2e7d32;
}

/* Responsive notifications */
@media (max-width: 600px) {
  .notification-alert {
    width: 90vw !important;
    max-width: 350px;
  }
}
</style>
